export default __webpack_public_path__ + "static/media/shoes13.a1b41ed6.jpeg";